import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PageResearchNotificationsSideInitizializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={{}}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageResearchNotificationsSideInitizializer.displayName =
  'Page Research NotificationsSide Side Initizializer component';

export default PageResearchNotificationsSideInitizializer;
